import { IComponentOptions } from "angular";
import { ProcessDetailController } from "./controller";

export const vsComponentName = "processDetail";

export const processDetailComponentNewOptions: IComponentOptions = {
  controller: ProcessDetailController,
  controllerAs: "processController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    processInformation: "<",
    processGroup: "<",
    process: "<",
  },
  transclude: {
    infoHeader: "infoHeader",
  },
};
